import React, { lazy, Suspense } from "react";
import LazyLoader from "../../components/common/loader/lazyLoader";
const NotFound = lazy(() => import("../../components/common/404"));

const NotFoundPage = () => {
  return (
    <>
      <Suspense fallback={<LazyLoader />}>
        <NotFound />
      </Suspense>
    </>
  );
};

export default NotFoundPage;
